import { render, staticRenderFns } from "./TemplateConfig.vue?vue&type=template&id=3451ca0b&scoped=true"
import script from "./TemplateConfig.vue?vue&type=script&lang=js"
export * from "./TemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./TemplateConfig.vue?vue&type=style&index=0&id=3451ca0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451ca0b",
  null
  
)

export default component.exports